import { Hint } from '@synoptic/ui-kit/hint/hint.js';
import { HelpCircleIcon } from '@synoptic/ui-kit/icons/react/help-circle.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { FC } from 'react';
import { CameraState } from 'sigma/types';
import { LayoutCard } from '@/components/layout/card';
import { FullscreenPage } from '@/components/layout/fullscreen-page';
import { NodeDataMini } from '@/services/twttr-graph-service';
import { GraphAdPanel } from './graph-ad-panel';
import { GraphWatermark } from './graph-watermark';
import { SigmaGraph } from './sigma-graph/sigma-graph.client';
import { SigmaNavigationPanel } from './sigma-graph/sigma-navigation-panel';
import { SigmaOptionsSection } from './sigma-graph/sigma-options-section';
import { SigmaSearch } from './sigma-graph/sigma-search';
import * as styles from './route.css';
import { floatingOptionsPanel } from './route.css';

export const XGraph: FC<{
  nodesData: NodeDataMini[];
  preview?: boolean;
  initialCameraState?: CameraState;
}> = ({ nodesData, preview, initialCameraState }) => {
  const isTablet = useIsTablet();

  return (
    <FullscreenPage>
      <LayoutCard className={styles.floatingTitlePanel}>
        <h1 className={styles.pageTitle}>
          Crypto Twitter Network Visualization
          {preview ? null : (
            <Hint description="The graph contains data of the most influential users in the crypto twitter network and the relationships between them.">
              <HelpCircleIcon />
            </Hint>
          )}
        </h1>
        {preview ? null : (
          <SigmaSearch data={nodesData} className={styles.searchInput} />
        )}

        {isTablet ? null : (
          <SigmaOptionsSection nodes={nodesData} preview={preview} />
        )}
      </LayoutCard>

      {isTablet ? (
        <LayoutCard className={floatingOptionsPanel} data-preview={preview}>
          <SigmaOptionsSection nodes={nodesData} preview={preview} />
        </LayoutCard>
      ) : null}

      {preview ? null : <GraphAdPanel />}

      {preview ? null : <SigmaNavigationPanel />}

      {preview ? <GraphWatermark /> : null}

      <SigmaGraph preview={preview} initialCameraState={initialCameraState} />
    </FullscreenPage>
  );
};
